import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Paper,
  Grid,
  Typography,
  InputAdornment,
  IconButton,
  Link,
  InputLabel,
  Select,
  FormControl,
  MenuItem,
  FormHelperText,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PasswordIcon from "@mui/icons-material/Password";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import { Container, Box } from "@mui/material";
import CustomizedProgressBars from "../CustomizedProgressBars";
import PageNotFound from "../404";
import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import BusinessIcon from "@mui/icons-material/Business";
import Footer from "../Footer";
import Banner from "../Banner";
import {
  checkDateIsAfterCurrentDate,
  firebaseConfig,
  languageType,
} from "../../../Utility/Helper";
import { ModeComment } from "@mui/icons-material";
import moment from "moment";
import plastindiaFoundationUpi from "../../../Assets/Images/plastindia-foundation-upi.jpg";
import axios from "axios";

const RegisterForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // Check if this is the specific ID that should hide language dropdown
  const isSpecificId = id === "017ac623-e25e-4235-a527-301bbd0acaaf";

  const particularLanguageShow = id === "deacab11-a51d-409d-b9be-72ae3c52a8c4";


  const isApplyForIncubation = id === "108284c9-5490-4929-9c48-70ff14bf3be3"

  

  const isShowQR =
    id === "e1d0c673-c649-4de3-947c-c8236f9f9860" ||
    id === "13d2d951-37a1-408f-9488-8db551ebdd45";

    const hideExtraFieldsSikkimRise =
  [
  "7d64421d-23be-4f1e-bfb6-a3bd55e9da4d",
  "e3d53ecf-98b7-4a03-a8af-b9c149aad530",
  "deacab11-a51d-409d-b9be-72ae3c52a8c4",
  "b08050aa-5824-478a-9d73-46649359b57b"
].includes(id);

  

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    email: "",
    mobileNumber: "",
    password: "",
    confirmPassword: "",
    // sector: "",
    // stage: "",
    location: "",
    // businessStructure: "",
    hearAboutUs: "", // Add hearAboutUs to formData
    language: isSpecificId ? "english" : "",
    agreeTnC: false,
    hereByConsent: false,
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    companyName: false,
    email: false,
    mobileNumber: false,
    password: false,
    confirmPassword: false,
    // sector: false,
    // stage: false,
    location: false,
    // businessStructure: false,
    hearAboutUs: false, // Add hearAboutUs to errors
    language: false,
    agreeTnC: false,
    hereByConsent: false,
  });
  const [passwordMatchError, setPasswordMatchError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isFirstSubmit, setIsFirstSubmit] = useState(false); // Add this line
  const [loading, setLoading] = useState(true);
  const [loadingFile, setLoadingFile] = useState(false);
  const [urlValid, setUrlValid] = useState(false);
  const [data, setData] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [sectorData, setSectorData] = useState([]);
  const [stageData, setStageData] = useState([]); // Add state for stage data
  const [locationData, setLocationData] = useState([]); // Add state for location data
  const [businessStructureData, setBusinessStructureData] = useState([]); // Add state for business structure data
  const [hearAboutUsOptions, setHearAboutUsOptions] = useState([]);
  // const isSpecificURL = id === "01aea58e-470f-457a-aee8-97bc8037823f";
  const [searchParams] = useSearchParams();
  const trackCode = searchParams.get("track");
  const app = initializeApp(firebaseConfig);
  const storage = getStorage(app);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedExtensions = [
      ".pdf",
      ".jpg",
      ".jpeg",
      ".doc",
      ".docx",
      ".ppt",
      ".pptx",
      ".xls",
      ".xlsx",
    ];
    const fileExtension = `.${file.name.split(".").pop().toLowerCase()}`;

    if (!allowedExtensions.includes(fileExtension)) {
      toast.error(
        "Please upload a .pdf / .jpg / .jpeg / .doc /.docx / .ppt / .pptx / .xls / .xlsx file only",
        {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          hideProgressBar: true,
        },
      );
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      toast.error("The size of your file is more than 5MB.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
      return;
    }

    try {
      setLoadingFile(true);

      const formData = new FormData();
      formData.append("file", file);
      formData.append("contestId", id);

      const response = await axios.post(
        `${
          process.env.REACT_APP_MODE === "production"
            ? process.env.REACT_APP_IMPORT_FILE_BASE_URL_PHP
            : process.env.REACT_APP_BASE_URL
        }/application/contest-file`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            // Authorization: `Bearer ${userData.accessToken}`,
          },
        },
      );

      if (response.status >= 200 && response.status < 300) {
        const { originalFileName, uploadedFileName } = response.data;
        setUploadedFile({ originalFileName, uploadedFileName, file });
        toast.success("File uploaded successfully", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          hideProgressBar: true,
        });
      } else {
        setUploadedFile(null);
        throw new Error("Failed to upload file. Please try again later.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadedFile(null);
      toast.error("Error uploading file. Please try again later", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } finally {
      setLoadingFile(false);
    }
  };

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  console.log("Track Code id in Register Page---", id);

  const TrackHits = async (code1) => {
    try {
      // console.log("Code", code1);
      const result = await fetch(
        `${process.env.REACT_APP_BASE_URL}/track-code/record`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify({
            contestId: id,
            code: code1,
            // applicationId: null,
          }),
        },
      );

      if (!result.ok) {
        console.warn(`TrackHits failed with status: ${result.status}`);
      }
      // console.log("result--",result)
    } catch (error) {
      console.error("Error in TrackHits:", error);
      // Don't throw error to prevent disrupting the main flow
    }
  };

  const validationURL = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/application/get-limited-contest-data/${id}`,
        {
          headers: {
            "Cache-Control": "no-cache",
          },
        },
      );
      if (response.ok) {
        setUrlValid(true);

        let data1;
        try {
          data1 = await response.json();
        } catch (parseError) {
          console.error("Failed to parse contest data response:", parseError);
          throw new Error("Invalid response format from server");
        }
        const { accessToken, publicId } = data;
        // Log the response body
        // if (trackCode) {
        //   const test=localStorage.getItem("track")
        //   if (!test){
        //     localStorage.setItem("track", JSON.stringify(trackCode));

        //   }
        // }
        if (trackCode) {
          localStorage.setItem("track", JSON.stringify(trackCode));

          // console.log("Track Code--- present--",trackCode)
          TrackHits(trackCode);
        } else {
          const storedTrack = localStorage.getItem("track");
          let code = null;

          if (storedTrack) {
            try {
              // Try to parse as JSON first, then clean up quotes
              const parsed =
                storedTrack.startsWith('"') && storedTrack.endsWith('"')
                  ? JSON.parse(storedTrack)
                  : storedTrack;
              code =
                typeof parsed === "string"
                  ? parsed.replace(/^"|"$/g, "")
                  : parsed;
            } catch (error) {
              // If parsing fails, just clean up quotes from the raw string
              code = storedTrack.replace(/^"|"$/g, "");
            }
          }

          console.log("Track code from local storage---", code);

          if (code) {
            localStorage.setItem("track", JSON.stringify(code));
            TrackHits(code);
          }
        }
        setData(data1);

        // Fetch the image URL from Firebase Storage
        if (
          data1.contestBanner &&
          data1.contestBanner[0] &&
          data1.contestBanner[0].uploadedFileName
        ) {
          // Fetch the image URL from Firebase Storage
          const fileRef = ref(
            storage,
            `/contest-banner/${data1.contestBanner[0].uploadedFileName}`,
          );
          try {
            const downloadURL = await getDownloadURL(fileRef);
            setImageUrl(downloadURL);
          } catch (error) {
            console.error("Error fetching image URL:", error);
            // Handle the error gracefully, e.g., by setting a default image URL
            // setImageUrl("/purpletree.png");
          }
        } else {
          // Handle the case where contest banner file name is not present in the response
          console.error("Contest banner file name not found in response data");
          // Set a default image URL or perform other necessary actions
          setImageUrl("/purpletree.png");
        }

        // Fetch the sector dropdown list
        const sectorResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/sector/drop-down-list`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );
        if (sectorResponse.ok) {
          try {
            const sectorData = await sectorResponse.json();
            setSectorData(sectorData); // Assuming you have a state to hold sector data
          } catch (error) {
            console.error("Failed to parse sector data:", error);
            setSectorData([]); // Set empty array as fallback
          }
        } else {
          console.error("Failed to fetch sector data");
        }

        // Fetch the Stage dropdown list

        const stageResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/stage/drop-down-list`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );
        if (stageResponse.ok) {
          try {
            const stageData = await stageResponse.json();
            setStageData(stageData);
          } catch (error) {
            console.error("Failed to parse stage data:", error);
            setStageData([]);
          }
        } else {
          console.error("Failed to fetch stage data");
        }

        // Fetch Location

        const locationResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/state/drop-down-list`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );
        if (locationResponse.ok) {
          try {
            const locationData = await locationResponse.json();
            setLocationData(locationData);
          } catch (error) {
            console.error("Failed to parse location data:", error);
            setLocationData([]);
          }
        } else {
          console.error("Failed to fetch location data");
        }

        // Fetch Business Structure

        const businessStructureResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/business-structure/drop-down-list`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );
        if (businessStructureResponse.ok) {
          try {
            const businessStructureData =
              await businessStructureResponse.json();
            setBusinessStructureData(businessStructureData);
          } catch (error) {
            console.error("Failed to parse business structure data:", error);
            setBusinessStructureData([]);
          }
        } else {
          console.error("Failed to fetch business structure data");
        }

        // Hear About us api call
        const hearResponse = await fetch(
          `${process.env.REACT_APP_BASE_URL}/hear-about/drop-down-list`,
          {
            headers: {
              "Cache-Control": "no-cache",
            },
          },
        );
        if (hearResponse.ok) {
          try {
            const hearData = await hearResponse.json();
            setHearAboutUsOptions(hearData);
          } catch (error) {
            console.error("Failed to parse hear about data:", error);
            setHearAboutUsOptions([]);
          }
        } else {
          console.error("Failed to fetch hear about data");
        }
      } else {
        setUrlValid(false);

        throw new Error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Please Check The URL, It`s Not a Valid Url ", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    validationURL();
    // console.log("Params---", id);
    // console.log("trackCode---", trackCode);
  }, [id]);

  useEffect(() => {
    // Validate form on first submit button click

    if (isFirstSubmit) {
      const formErrors = {};
      let hasErrors = false;

      // Validate required fields
      Object.entries(formData).forEach(([key, value]) => {
        switch (key) {
          // String-based required fields
          case "firstName":
          case "lastName":
          case "companyName":
          case "email":
          case "mobileNumber":
          case "password":
          case "confirmPassword":
            if (typeof value !== "string" || value.trim() === "") {
              formErrors[key] = true;
              hasErrors = true;
            }
            break;

          // Checkbox / boolean
          case "agreeTnC":
            if (isShowQR && value !== true) {
              formErrors[key] = true;
              hasErrors = true;
            }
            break;
          case "hereByConsent":
            if ( value !== true) {
              formErrors[key] = true;
              hasErrors = true;
            }
            break;

          // Selects / dropdowns that store string
          case "location":
          // case "hearAboutUs":
          // case "language":

          //   if (hideExtraFieldsSikkimRise) {
          //       formErrors[key] = false;
          //       break;
          //   }

          //   if (typeof value !== "string" || value.trim() === "") {
          //     formErrors[key] = true;
          //     hasErrors = true;
          //   }
          //   break;

          default:
            // For any other fields you might have
            if (
              value === null ||
              value === undefined ||
              (typeof value === "string" && value.trim() === "")
            ) {
              formErrors[key] = true;
              hasErrors = true;
            }
        }
      });

      // Check email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (formData.email.trim() !== "" && !emailRegex.test(formData.email)) {
        formErrors.email = true;
        hasErrors = true;
      }

      // Check mobile number digits
      if (
        formData.mobileNumber.trim() !== "" &&
        (formData.mobileNumber.trim().length !== 10 ||
          isNaN(formData.mobileNumber.trim()))
      ) {
        formErrors.mobileNumber = true;
        hasErrors = true;
      }

      // Check first name length
      if (formData.firstName.trim().length < 2) {
        formErrors.firstName = true;
        hasErrors = true;
      }
      // Check first name length
      if (formData.companyName.trim().length < 2) {
        formErrors.companyName = true;
        hasErrors = true;
      }
      // Check last name length
      if (formData.lastName.trim().length < 2) {
        formErrors.lastName = true;
        hasErrors = true;
      }

      // ✅ Agree to Terms validation (only if isShowQR is true)
      if (isShowQR && !formData.agreeTnC) {
        formErrors.agreeTnC = true;
        hasErrors = true;
      }

      if ( !formData.hereByConsent) {
        formErrors.hereByConsent = true;
        hasErrors = true;
      }

      setErrors(formErrors);

      // Set isFirstSubmit to false after initial form validation
      setIsFirstSubmit(false);
    }
  }, [formData, isFirstSubmit, isShowQR,hideExtraFieldsSikkimRise]);

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === "",
    }));
  };

  const handleSectorChange = (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      sector: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      sector: value === "",
    }));
  };
  const handleStageChange = (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      stage: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      stage: value === "",
    }));
  };
  const handleLocationChange = (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      location: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      location: value === "",
    }));
  };

  const handleBusinessStructureChange = (event) => {
    const { value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      businessStructure: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      businessStructure: value === "",
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Validation logic on blur
    if (name === "mobileNumber") {
      if (value.trim().length !== 10 || isNaN(value.trim())) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: true,
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false,
        }));
      }
    } else if (name === "firstName" || name === "lastName") {
      if (value.trim().length < 2) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: true,
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false,
        }));
      }
    } else {
      if (value.trim() === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: true,
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false,
        }));
      }
    }

    // Reset password match error on password change
    if (name === "password" || name === "confirmPassword") {
      setPasswordMatchError(false);
    }
  };

  // console.log(errors, "called23");

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setIsFirstSubmit(true);
  //   // console.log("Params---", id);
  //   // Check for sector, stage, location, businessStructure, and hearAboutUs selection
  //   // if (
  //   //   formData.sector === "" ||
  //   //   formData.stage === "" ||
  //   //   formData.location === "" ||
  //   //   formData.businessStructure === "" ||
  //   //   formData.hearAboutUs === "" ||
  //   //   formData.language === ""
  //   // ) {
  //   //   setErrors((prevErrors) => ({
  //   //     ...prevErrors,
  //   //     sector: formData.sector === "",
  //   //     stage: formData.stage === "",
  //   //     location: formData.location === "",
  //   //     businessStructure: formData.businessStructure === "",
  //   //     hearAboutUs: formData.hearAboutUs === "",
  //   //     language: formData.language === "",
  //   //   }));
  //   //   return;
  //   // }
  //   // console.log(errors, "called2");
  //   // if (isSpecificURL) {
  //   //   if (
  //   //     formData.location === "" ||
  //   //     formData.hearAboutUs === "" ||
  //   //     formData.language === ""
  //   //   ) {
  //   //     setErrors((prevErrors) => ({
  //   //       ...prevErrors,
  //   //       location: formData.location === "",
  //   //       hearAboutUs: formData.hearAboutUs === "",
  //   //       language: formData.language === "",
  //   //       sector: false,
  //   //       stage: false,
  //   //       businessStructure: false,
  //   //     }));
  //   //     return;
  //   //   }
  //   // } else {

  //   // }
  //   if (
  //     // formData.sector === "" ||
  //     // formData.stage === "" ||
  //     formData.location === "" ||
  //     // formData.businessStructure === "" ||
  //     formData.hearAboutUs === "" ||
  //     formData.language === ""
  //   ) {
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       // sector: formData.sector === "",
  //       // stage: formData.stage === "",
  //       location: formData.location === "",
  //       // businessStructure: formData.businessStructure === "",
  //       hearAboutUs: formData.hearAboutUs === "",
  //       language: formData.language === "",
  //     }));
  //     return;
  //   }
  //   // console.log(errors, "called3");
  //   const hasErrors =
  //     Object.values(errors).some((error) => error === true) ||
  //     passwordMatchError;

  //   if (hasErrors) {
  //     // If there are errors, do not proceed with submission
  //     return;
  //   }

  //   if (formData.password !== formData.confirmPassword) {
  //     // console.log("PAssword---", formData.password);
  //     // console.log("confirmPassword---", formData.confirmPassword);

  //     // If passwords do not match, show an error message
  //     toast.error("Both Passwords must match!", {
  //       position: "top-right",
  //       autoClose: 3000,
  //       theme: "colored",
  //       hideProgressBar: true,
  //     });
  //     return;
  //   }

  //   try {
  //     // const payload = {
  //     //   firstName: formData.firstName,
  //     //   lastName: formData.lastName,
  //     //   email: formData.email,
  //     //   companyName: formData.companyName,
  //     //   state: formData.location,
  //     //   phoneNumber: formData.mobileNumber,
  //     //   password: formData.password,
  //     //   hearAboutUs: formData.hearAboutUs,
  //     //   language: formData.language,
  //     //   status: "draft",
  //     // };

  //     // if (!isSpecificURL) {
  //     //   payload.sector = formData.sector;
  //     //   payload.stage = formData.stage;
  //     //   payload.businessStructure = formData.businessStructure;
  //     // }
  //     // console.log("Payload-----", payload);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/application`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Cache-Control": "no-cache",
  //         },

  //         body: JSON.stringify({
  //           formId: id,
  //           firstName: formData.firstName,
  //           lastName: formData.lastName,
  //           companyName: formData.companyName,
  //           email: formData.email,
  //           phoneNumber: formData.mobileNumber,
  //           password: formData.password,
  //           // sector: formData.sector,
  //           // stage: formData.stage,
  //           state: formData.location,
  //           // businessStructure: formData.businessStructure,
  //           hearAboutUs: formData.hearAboutUs,
  //           language: formData.language,
  //           status: "draft",
  //         }),
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       const { accessToken, publicId } = data;
  //       localStorage.setItem("datadata", JSON.stringify(data));

  //       // Create user object with necessary details
  //       const user = {
  //         accessToken: accessToken,
  //         userId: publicId,
  //         contestId: id,
  //       };

  //       // Store user object in local storage
  //       localStorage.setItem("user", JSON.stringify(user));

  //       let finalTrackCode = trackCode;
  //       if (!finalTrackCode) {
  //         finalTrackCode = localStorage.getItem("track")?.replace(/^"|"$/g, '') || null;
  //       }
  //       //Api call for record
  //       try {
  //         const trackResponse = await fetch(
  //           `${process.env.REACT_APP_BASE_URL}/track-code/record`,
  //           {
  //             method: "POST",
  //             headers: {
  //               "Content-Type": "application/json",
  //               "Cache-Control": "no-cache",
  //               Authorization: `Bearer ${accessToken}`,
  //             },
  //             body: JSON.stringify({
  //               contestId: id,
  //               code: finalTrackCode,
  //               applicationId: data?.publicId,
  //             }),
  //           }
  //         );
  //         if (!trackResponse.ok) {
  //           console.error("Tracking failed:", await trackResponse.json());
  //           // Optionally store failed tracking to retry later
  //         }
  //         // // Check if the track code recording was successful
  //         // const debugMode = true; // Set to false in production
  //         // if (debugMode && trackCode) {
  //         //   const result = await trackResponse.json();
  //         //   console.log("Tracking API response:589-", result);
  //         //   alert(
  //         //     `Tracking API Status: ${
  //         //       trackResponse.status
  //         //     }\nResponse: ${JSON.stringify(result)}`
  //         //   );
  //         // }
  //       } catch (trackError) {
  //         console.error("Error recording track code:", trackError);
  //       }
  //       const navigatePath = trackCode
  //         ? `/dashboard/${id}?track=${trackCode}`
  //         : `/dashboard/${id}`;

  //       navigate(navigatePath);

  //       // Show success message after navigation
  //       toast.success("Registered Successfully.", {
  //         position: "top-right",
  //         autoClose: 3000,
  //         theme: "colored",
  //         hideProgressBar: true,
  //       });
  //       // window.location.reload(true);
  //       console.log("ACX", {
  //         contestId: id,
  //         code: trackCode,
  //         applicationId: publicId,
  //       });
  //     } else {
  //       const errorMessage = await response.json(); // Assuming error message is in JSON format
  //       console.error("Registration failed:", errorMessage.message);

  //       if (
  //         Array.isArray(errorMessage.message) &&
  //         errorMessage.message.length > 0
  //       ) {
  //         errorMessage.message.forEach((error) => {
  //           toast.error(error, {
  //             position: "top-right",
  //             autoClose: 3000,
  //             theme: "colored",
  //             hideProgressBar: true,
  //           });
  //         });
  //       } else if (typeof errorMessage.message === "string") {
  //         console.error("Error Message:", errorMessage.message);
  //         toast.error(errorMessage.message, {
  //           position: "top-right",
  //           autoClose: 3000,
  //           theme: "colored",
  //           hideProgressBar: true,
  //         });
  //       } else {
  //         // In case the error message is not an array or string, display a generic error
  //         toast.error("An unexpected error occurred. Please try again later.", {
  //           position: "top-right",
  //           autoClose: 3000,
  //           theme: "colored",
  //           hideProgressBar: true,
  //         });
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Registration failed:", error.message);
  //     toast.error(error.message, {
  //       position: "top-right",
  //       autoClose: 3000,
  //       theme: "colored",
  //       hideProgressBar: true,
  //     });
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFirstSubmit(true);
console.log("call-938")
    // Validate required fields
  if (
  (!hideExtraFieldsSikkimRise && formData.location === "") //||
  // (!hideExtraFieldsSikkimRise && formData.hearAboutUs === "") ||
  // (!isSpecificId &&
  //   !hideExtraFieldsSikkimRise &&
  //   formData.language === "")
) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        location: !hideExtraFieldsSikkimRise && formData.location === "",
        // hearAboutUs: !hideExtraFieldsSikkimRise && formData.hearAboutUs === "",
        // language: !isSpecificId && !hideExtraFieldsSikkimRise && formData.language === "",
        hereByConsent: isShowQR && !formData.hereByConsent, // ✅ Set checkbox error
      }));
      return;
    }

    // Check for other validation errors
    const hasErrors =
      Object.values(errors).some((error) => error) || passwordMatchError;
      console.log("call-938",errors, passwordMatchError)
    if (hasErrors) return;

    console.log("call-938")

    // Validate password match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Both Passwords must match!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
      return;
    }

    // if(isShowQR && !(uploadedFile?.uploadedFileName && uploadedFile?.originalFileName) ){
    //       toast.error("Please upload screenshot.", {
    //     position: "top-right",
    //     autoClose: 3000,
    //     theme: "colored",
    //     hideProgressBar: true,
    //   });
    //   return;
    // }

    try {
      // Prepare registration payload
      const payload = {
        formId: id,
        firstName: formData.firstName,
        lastName: formData.lastName,
        companyName: formData.companyName,
        email: formData.email,
        phoneNumber: formData.mobileNumber,
        password: formData.password,
        status: "draft",
          // Add only when fields are visible
      ...(!hideExtraFieldsSikkimRise && {
        state: formData.location,
        hearAboutUs: formData.hearAboutUs,
        language: isSpecificId ? "english" : formData.language,
      })
        //...(isShowQR && {uploadedFileName: uploadedFile?.uploadedFileName ,originalFileName: uploadedFile?.originalFileName  }),
      };

      // Submit registration
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/application`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        let errorData;
        try {
          // Check if response is JSON
          const contentType = response.headers.get("content-type");
          if (contentType && contentType.includes("application/json")) {
            errorData = await response.json();
          } else {
            // If not JSON, get text and create error object
            const errorText = await response.text();
            errorData = {
              message: `Server error (${response.status}): ${errorText || "Unknown error"}`,
            };
          }
        } catch (parseError) {
          // If parsing fails, create a generic error
          errorData = {
            message: `Server error (${response.status}): Failed to parse response`,
          };
        }
        handleRegistrationError(errorData);
        return;
      }

      let responseData;
      try {
        responseData = await response.json();
      } catch (parseError) {
        console.error("Failed to parse response as JSON:", parseError);
        toast.error("Invalid response from server. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          hideProgressBar: true,
        });
        return;
      }
      const { accessToken, publicId } = responseData;

      // Store user data
      storeUserData(responseData, accessToken, publicId);

      // Handle track code
      await handleTrackCode(accessToken, publicId);

      // Navigate to dashboard
      navigateToDashboard(publicId);

      // Show success message
      toast.success("Registered Successfully.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } catch (error) {
      console.error("Registration failed:", error);
      toast.error(error.message || "Registration failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    }
  };

  const handleSubmitPayment = async (e) => {
    e.preventDefault();
    setIsFirstSubmit(true);

    // Validate required fields
    if (
      formData.location === "" ||
      // formData.hearAboutUs === "" ||
      // (!isSpecificId && formData.language === "") ||
      (isShowQR && !formData.agreeTnC) // ✅ Add checkbox check
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        location: formData.location === "",
        // hearAboutUs: formData.hearAboutUs === "",
        // language: !isSpecificId && formData.language === "",
        agreeTnC: isShowQR && !formData.agreeTnC, // ✅ Set checkbox error
        hereByConsent: isShowQR && !formData.hereByConsent, // ✅ Set checkbox error
      }));
      return;
    }

    // Check for other validation errors
    const hasErrors =
      Object.values(errors).some((error) => error) || passwordMatchError;
    if (hasErrors) return;

    // Validate password match
    if (formData.password !== formData.confirmPassword) {
      toast.error("Both Passwords must match!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
      return;
    }

    try {
      // Prepare registration payload
      const payload = {
        formId: id,
        firstName: formData.firstName,
        lastName: formData.lastName,
        companyName: formData.companyName,
        email: formData.email,
        phoneNumber: formData.mobileNumber,
        password: formData.password,
        state: formData.location,
        hearAboutUs: formData.hearAboutUs,
        language: isSpecificId ? "english" : formData.language,
        status: "draft",
        ...(isShowQR && {
          amount: 2000,
          // currency: "INR",
          // redirectUrl: `${window.location.origin}/payment/success/${id}`,
          // cancelUrl:  `${window.location.origin}/payment/fail/${id}`,
        }),
      };

      // Validate payload before sending
      if (!payload || typeof payload !== "object") {
        throw new Error("Invalid payment data");
      }

      // ********************* payment api Start ***************

      // Build API URL securely from environment variables
      const apiUrl = `${process.env.REACT_APP_BASE_URL}/payment/initiate`;
      if (!apiUrl.startsWith("https://")) {
        console.warn(
          "⚠️ Warning: API URL should use HTTPS for secure communication",
        );
      }

      setLoadingFile(true);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        },
        body: JSON.stringify(payload),
      });

      // Handle network or server errors
      if (!response.ok) {
        const errorText = await response.json();

        throw new Error(
          errorText?.message ??
            `Server error (${response.status}): ${errorText}`,
        );
      }

      let responseData = await response.json();

      const { ccavenueUrl, access_code, encRequest } = responseData || {};

      if (!ccavenueUrl || !access_code || !encRequest) {
        throw new Error("Invalid response from payment gateway");
      }

      // Redirect securely with limited sensitive data
      navigate("/payment/redirect", {
        state: {
          ccavenueUrl,
          access_code,
          encRequest,
        },
        replace: true, // Prevent storing sensitive data in history
      });

      // ********************* payment api End *****************
    } catch (error) {
      console.error("Registration failed:", error);
      toast.error(error.message || "Registration failed. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } finally {
      setLoadingFile(false);
    }
  };

  // Helper functions
  const storeUserData = (data, accessToken, publicId) => {
    localStorage.setItem("datadata", JSON.stringify(data));
    localStorage.setItem(
      "user",
      JSON.stringify({
        accessToken,
        userId: publicId,
        contestId: id,
      }),
    );
  };

  const getTrackCode = () => {
    // First check URL params, then localStorage
    const urlTrackCode = trackCode;
    if (urlTrackCode) return urlTrackCode;

    const storedTrackCode = localStorage.getItem("track");
    if (storedTrackCode) {
      try {
        // Handle both JSON string and plain string values
        return storedTrackCode.startsWith('"') && storedTrackCode.endsWith('"')
          ? JSON.parse(storedTrackCode)
          : storedTrackCode;
      } catch (error) {
        console.warn("Error parsing track code from localStorage:", error);
        return storedTrackCode; // Return as-is if JSON parsing fails
      }
    }
    return null;
  };

  const handleTrackCode = async (accessToken, applicationId) => {
    const finalTrackCode = getTrackCode();
    if (!finalTrackCode) return;

    try {
      const trackResponse = await fetch(
        `${process.env.REACT_APP_BASE_URL}/track-code/record`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            contestId: id,
            code: finalTrackCode,
            applicationId,
          }),
        },
      );

      if (!trackResponse.ok) {
        try {
          const errorData = await trackResponse.json();
          console.error("Tracking failed:", errorData);
        } catch (error) {
          console.error(
            "Tracking failed with unparseable response:",
            trackResponse.status,
          );
        }
      }
    } catch (trackError) {
      console.error("Error recording track code:", trackError);
    }
  };

  const navigateToDashboard = (publicId) => {
    const finalTrackCode = getTrackCode();
    const navigatePath = finalTrackCode
      ? `/dashboard/${id}?track=${finalTrackCode}`
      : `/dashboard/${id}`;
    navigate(navigatePath);
  };

  const handleRegistrationError = (errorData) => {
    if (Array.isArray(errorData.message)) {
      errorData.message.forEach((error) => {
        toast.error(error, {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
          hideProgressBar: true,
        });
      });
    } else if (typeof errorData.message === "string") {
      toast.error(errorData.message, {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    } else {
      toast.error("An unexpected error occurred. Please try again later.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
        hideProgressBar: true,
      });
    }
  };
  const handleBack = () => {
    const navigatePath = trackCode
      ? `/login/${id}?track=${trackCode}`
      : `/login/${id}`;
    navigate(navigatePath); // Navigate back to the login page
  };
  const handleLogin = () => {
    const navigatePath = trackCode
      ? `/login/${id}?track=${trackCode}`
      : `/login/${id}`;
    navigate(navigatePath); // Navigate back to the login page
  };
  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword,
    );
  };
  if (loading) {
    return (
      <>
        <CustomizedProgressBars />
      </>
    );
  }
  return (
    <>
      {urlValid ? (
        <>
          {/* Navbar */}

          <Banner />
          {/* <Container
            sx={{
              backgroundColor: "#2d75a1",
              width: "100%",
              // height: "100px",
              height: "auto",
              minHeight:"100px",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              mt: 2, // Add spacing to the top
            }}
          >
            <Typography variant="h4" align="center" sx={{ fontWeight: "bold" }}>
              Contest Name:{" "}
              {data && data.contestName ? data.contestName : "No Data Found"}
            </Typography>
            
            <Typography variant="body1" align="left">
              Sponsored By -{" "}
              {data && data.companyName ? data.companyName : "No Data Found"}
            </Typography>
          </Container> */}

          <Container sx={{ mt: 2 }}>
            <Grid
              container
              spacing={5}
              alignItems="center"
              justifyContent="center"
              py={1}
            >
              {/* For Demo Purpose */}
              {/* <Grid item xs={12} md={5}>
                <Box textAlign="center">
                  <img
                    src="https://bootstrapious.com/i/snippets/sn-registeration/illustration.svg"
                    alt=""
                    className="img-fluid mb-3 d-none d-md-block"
                    style={{
                      maxWidth: "400px",
                      background: "cadetblue",
                      borderRadius: "50px",
                      border: "15px solid cadetblue",
                    }}
                  />
                </Box>
              </Grid> */}

              {/* Registration Form */}
              <Grid item xs={12} md={7}>
                <Typography
                  variant="h4"
                  color="primary"
                  textAlign={"center"}
                  sx={{ mb: 2 }}
                  gutterBottom
                >
                  Create An Account
                </Typography>
                <form onSubmit={isShowQR ? handleSubmitPayment : handleSubmit}>
                  <Grid container spacing={2}>
                    {/* First Name */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="First Name"
                        name="firstName"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <PermIdentityIcon
                              sx={{
                                mr: 1,
                                color: errors.firstName ? "red" : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),
                        }}
                        value={formData.firstName}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.firstName}
                        fullWidth
                        variant="outlined"
                        helperText={
                          errors.firstName
                            ? "First Name should be at least 2 letters"
                            : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                      />
                    </Grid>{" "}
                    {/* Last Name */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Last Name"
                        name="lastName"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <PermIdentityIcon
                              sx={{
                                mr: 1,
                                color: errors.lastName ? "red" : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),
                        }}
                        value={formData.lastName}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.lastName}
                        fullWidth
                        variant="outlined"
                        helperText={
                          errors.lastName
                            ? "Last Name should be at least 2 letters"
                            : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                      />{" "}
                    </Grid>
                    {/* Company Name */}
                    <Grid item xs={12} sm={12}>
                      <TextField
                        label={    hideExtraFieldsSikkimRise
                        ? "Business Name / Project Name"
                        : `Company Name ${isShowQR ? "/ Project Name" : ""}`}
                        name="companyName"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <BusinessIcon
                              sx={{
                                mr: 1,
                                color: errors.companyName ? "red" : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),
                        }}
                        value={formData.companyName}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.companyName}
                        fullWidth
                        variant="outlined"
                        helperText={
                          errors.companyName
                            ? `${
                              hideExtraFieldsSikkimRise
                                    ? "Business Name / Project Name"
                                    : `Company Name ${isShowQR ? "/ Project Name" : ""}`
                                } should be at least 2 letters`
                            : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                      />
                    </Grid>{" "}
                    {/* Sector and Stage */}
                    {/* <Grid item xs={12} sm={6}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              <InputLabel id="sector-select-label">
                                Sector
                              </InputLabel>
                              <Select
                                labelId="sector-select-label"
                                id="sector-select"
                                value={formData.sector}
                                onChange={handleSectorChange}
                                label="Sector"
                                error={!!errors.sector}
                              >
                                {sectorData.map((sector) => (
                                  <MenuItem
                                    key={sector._id}
                                    value={sector.name}
                                  >
                                    {sector.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.sector && (
                                <FormHelperText error>
                                  Please Select Sector
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              <InputLabel id="stage-select-label">
                                Stage
                              </InputLabel>
                              <Select
                                labelId="stage-select-label"
                                id="stage-select"
                                value={formData.stage}
                                onChange={handleStageChange}
                                label="Stage"
                                error={!!errors.stage}
                              >
                                {stageData.map((stage) => (
                                  <MenuItem key={stage._id} value={stage.name}>
                                    {stage.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.stage && (
                                <FormHelperText error>
                                  Please Select Stage
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Grid>{" "} */}
                    {/* Location States ////   Business */}

                    {

                      !hideExtraFieldsSikkimRise &&
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="location-select-label">
                          Location/State
                        </InputLabel>
                        <Select
                          labelId="location-select-label"
                          id="location-select"
                          value={formData.location}
                          onChange={handleLocationChange}
                          label="Location/State"
                          error={!!errors.location}
                        >
                          {locationData.map((location) => (
                            <MenuItem key={location._id} value={location.name}>
                              {location.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.location && (
                          <FormHelperText error>
                            Please Select Location/State
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    }
                    {/* Buysiness Dropdown */}
                    {/* <Grid item xs={12} sm={6}>
                            <FormControl
                              fullWidth
                              variant="outlined"
                              size="small"
                            >
                              <InputLabel id="business-structure-select-label">
                                Business Structure
                              </InputLabel>
                              <Select
                                labelId="business-structure-select-label"
                                id="business-structure-select"
                                value={formData.businessStructure}
                                onChange={handleBusinessStructureChange}
                                label="Business Structure"
                                error={!!errors.businessStructure}
                              >
                                {businessStructureData.map((structure) => (
                                  <MenuItem
                                    key={structure._id}
                                    value={structure.name}
                                  >
                                    {structure.name}
                                  </MenuItem>
                                ))}
                              </Select>
                              {errors.businessStructure && (
                                <FormHelperText error>
                                  Please Select Business Structure
                                </FormHelperText>
                              )}
                            </FormControl>
                          </Grid> */}
                    {/* Email Address */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Email"
                        name="email"
                        size="small"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.email}
                        fullWidth
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <EmailIcon
                              sx={{
                                mr: 1,
                                color: errors.email ? "red" : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),
                        }}
                        type="email"
                        helperText={errors.email ? "Invalid Email" : ""}
                        autoComplete="off" // Add this prop to disable auto suggestion
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Mobile Number"
                        name="mobileNumber"
                        size="small"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.mobileNumber}
                        fullWidth
                        InputProps={{
                          // startAdornment: (
                          //   <LocalPhoneIcon
                          //     sx={{
                          //       mr: 1,
                          //       color: errors.mobileNumber
                          //         ? "red"
                          //         : "inherit",
                          //       maxWidth: "18px",
                          //     }}
                          //   />
                          // ),
                          startAdornment: (
                            <InputAdornment position="start">
                              <LocalPhoneIcon
                                sx={{
                                  mr: 1,
                                  color: errors.mobileNumber
                                    ? "red"
                                    : "inherit",
                                  maxWidth: "18px",
                                }}
                              />
                              +91
                            </InputAdornment>
                          ),
                        }}
                        variant="outlined"
                        helperText={
                          errors.mobileNumber
                            ? "Mobile number needs 10 digits"
                            : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                      />
                    </Grid>
                    {/* Password */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Password"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.password}
                        size="small"
                        fullWidth
                        variant="outlined"
                        type={showPassword ? "text" : "password"}
                        helperText={
                          errors.password ? "Password cannot be empty" : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                        InputProps={{
                          startAdornment: (
                            <LockIcon
                              sx={{
                                mr: 1,
                                color: errors.password ? "red" : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),

                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleTogglePasswordVisibility}
                              >
                                {showPassword ? (
                                  <VisibilityIcon sx={{ maxWidth: "18px" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ maxWidth: "18px" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {/* Password Confirmation */}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Confirm Password"
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        onBlur={handleChange}
                        error={errors.confirmPassword}
                        fullWidth
                        size="small"
                        variant="outlined"
                        type={showConfirmPassword ? "text" : "password"}
                        helperText={
                          errors.confirmPassword
                            ? " Confirm Password cannot be empty"
                            : ""
                        }
                        autoComplete="off" // Add this prop to disable auto suggestion
                        InputProps={{
                          startAdornment: (
                            <LockIcon
                              sx={{
                                mr: 1,
                                color: errors.confirmPassword
                                  ? "red"
                                  : "inherit",
                                maxWidth: "18px",
                              }}
                            />
                          ),

                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={handleToggleConfirmPasswordVisibility}
                              >
                                {showConfirmPassword ? (
                                  <VisibilityIcon sx={{ maxWidth: "18px" }} />
                                ) : (
                                  <VisibilityOffIcon
                                    sx={{ maxWidth: "18px" }}
                                  />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {/* Hear About Us */}

                    {/* {
                      !hideExtraFieldsSikkimRise &&
                    <Grid item xs={12} sm={6}>
                      <FormControl fullWidth variant="outlined" size="small">
                        <InputLabel id="hear-about-us-select-label">
                          From Where Do You Hear About Us?
                        </InputLabel>
                        <Select
                          labelId="hear-about-us-select-label"
                          id="hear-about-us-select"
                          name="hearAboutUs"
                          value={formData.hearAboutUs}
                          onChange={handleDropdownChange}
                          label="From Where Do You Hear About Us?"
                          error={!!errors.hearAboutUs}
                        >
                          {hearAboutUsOptions.map((option) => (
                            <MenuItem
                              key={option._id}
                              value={option.name}
                              style={{
                                whiteSpace: "break-spaces",
                                wordBreak: "break-word",
                              }}
                            >
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.hearAboutUs && (
                          <FormHelperText error>
                            Please Select Where You Heard About Us
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    } */}
                    {/* Language */}
                    {/* {!isSpecificId &&  !hideExtraFieldsSikkimRise && (
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" size="small">
                          <InputLabel id="language-label">
                            Language to be used in Application
                          </InputLabel>
                          <Select
                            labelId="language-label"
                            id="language-select"
                            name="language"
                            value={formData.language}
                            onChange={handleDropdownChange}
                            label="Language to be used in Application"
                            error={!!errors.language}
                          >
                            {languageType
                              .filter((option) =>
                                isShowQR || particularLanguageShow
                                  ? ["english", "hindi"].includes(option.value)
                                  : true,
                              )
                              .map((option) => (
                                <MenuItem
                                  key={`lang-${option.value}`}
                                  value={option.value}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                          </Select>
                          {errors.language && (
                            <FormHelperText error>
                              Please Select Language to be used in Application
                            </FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    )} */}

                              <>
                  <Grid item xs={12}>
                        <FormControlLabel
                          sx={{
                            alignItems: "flex-start",
                            marginLeft: 0,
                            marginRight: 0,
                            "& .MuiCheckbox-root": {
                              paddingTop: "2px",
                              marginRight: "8px",
                            },
                          }}
                          control={
                            <Checkbox
                              checked={formData.hereByConsent || false}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  hereByConsent: e.target.checked,
                                })
                              }
                              name="hereByConsent"
                              color="primary"
                            />
                          }
                          label={
                              <Typography
                                variant="body2"
                                sx={{
                                  lineHeight: 1.7,
                                  textAlign: "justify",
                                  color: "text.primary",
                                }}
                              >
                              I hereby agree to share my e-mail ID, Mobile Number, Demographic details with IIM Calcutta Innovation Park for the purpose of the programme’s administration, evaluation, and other programme related communication purposes / future programs and events as and when organized and deemed applicable with this application form.

                                <Box component="span" sx={{ display: "block", mt: 1 }}>
                                I hereby consent IIM Calcutta Innovation Park to reach out to me to share information about future programs and incubation activities.
                                </Box>
                              </Typography>
                            }
                          />

                          {errors.hereByConsent && (
                            <FormHelperText error sx={{ ml: 4 }}>
                              You must agree before proceeding.
                            </FormHelperText>
                          )}
                        </Grid>

                       
                      </>
                    {isShowQR && (
                      <>
                        <Grid item xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={formData.agreeTnC || false}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    agreeTnC: e.target.checked,
                                  })
                                }
                                name="agreeTnC"
                                color="primary"
                              />
                            }
                            label={
                              <Typography variant="body2">
                                I agree to{" "}
                                <Link
                                  href={`/terms-and-conditions/${id}`}
                                  target="_blank"
                                >
                                  Terms and Conditions
                                </Link>{" "}
                                and{" "}
                                <Link
                                  href={`/privacy-policy/${id}`}
                                  target="_blank"
                                >
                                  Privacy Policy
                                </Link>
                              </Typography>
                            }
                          />
                          {errors.agreeTnC && (
                            <FormHelperText error>
                              You must agree before proceeding.
                            </FormHelperText>
                          )}
                        </Grid>

                        <Grid item xs={12} sm={12}>
                          {/* Terms & Conditions link */}
                          <Typography
                            variant="body1"
                            sx={{
                              display: "block",
                              mt: 1,
                              textAlign: "center",
                            }}
                          >
                            <Button
                              variant="text"
                              sx={{
                                p: 0,
                                textTransform: "none",
                                cursor: "default",
                              }}
                            >
                              You will be charged an application fee of INR 2000
                              (inclusive of GST) to participate in BharatNext
                              Challenge - PlastIndia Foundation Startup Search
                              2026
                            </Button>
                          </Typography>
                        </Grid>
                      </>
                    )}
                  
            
                  
                  </Grid>

                  {/* Submit Button */}
                  <Grid item xs={12} style={{ textAlign: "center" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      color="success"
                      sx={{ mt: 2 }}
                      disabled={
                        data?.contestEndDate
                          ? checkDateIsAfterCurrentDate(data?.contestEndDate)
                            ? checkDateIsAfterCurrentDate(data?.contestEndDate)
                            : loadingFile
                              ? loadingFile
                              : false
                          : loadingFile
                            ? loadingFile
                            : false
                      }
                    >
                      {isShowQR
                        ? "Pay Application Fees"
                        : "Create Your Account"}
                    </Button>
                  </Grid>

                  {/* Divider Text */}
                  <Grid item xs={12}>
                    <Box display="flex" alignItems="center">
                      <Box
                        flexGrow={1}
                        borderBottom={2}
                        borderColor="text.disabled"
                      />
                      <Typography variant="body2" color="textSecondary" px={2}>
                        OR
                      </Typography>
                      <Box
                        flexGrow={1}
                        borderBottom={2}
                        borderColor="text.disabled"
                      />
                    </Box>
                  </Grid>

                  {/* Already Registered */}
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      align="center"
                      className="text-primary"
                      style={{ cursor: "pointer" }}
                      sx={{ marginBottom: 14 }} // Adding margin bottom using sx prop
                    >
                      Already Registered?
                      <Link onClick={handleLogin} color="primary">
                        Log in
                      </Link>
                    </Typography>
                  </Grid>
                </form>
              </Grid>
                    {/* Disclaimer */}
            {isApplyForIncubation && (
              <Box
                sx={{
            
                  mb: 3,
                  px: 2,
                  py: 2,
                  backgroundColor: "#f8f8f8",
                  borderRadius: 1,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "14px",
                    lineHeight: 1.6,
                    color: "#555",
                  }}
                >
                  <strong>Disclaimer:</strong>{" "}
                  IIM Calcutta Innovation Park (IIMCIP) never asks for payment to apply
                  for funding or business support. No individual is authorised to
                  guarantee funding on IIMCIP’s behalf in exchange for money. Please
                  report any such fraudulent requests to IIMCIP immediately at{" "}
                  <Link href="mailto:contact@iimcip.org">
                    contact@iimcip.org
                  </Link>
                </Typography>
              </Box>
            )}

            </Grid>
          </Container>
        </>
      ) : (
        <>
          <PageNotFound />
        </>
      )}


      <p />
      {/* <Footer /> */}
    </>
  );
};

export default RegisterForm;
